module.exports = __webpack_public_path__ + "img/MEDIA072.f4e83f53.jpg";